import { useLocalStorage, useSessionStorage } from '@vueuse/core'

export const email_address = useLocalStorage('email_address', null)

export const redirect_path = useSessionStorage('redirect_url', null)

export const fingerprint_id = useLocalStorage('fingerprint_id', null)

export const renewal_order_id = useSessionStorage('renewal_order_id', null)

export const renewal_email_address = useSessionStorage('renewal_email_address', null)

export const invalid_renewal_email = useSessionStorage('invalid_renewal_email', false)

// Where to land once a freshly-converted account clears the onboarding chain
// (accept terms -> process). Lets a converting guest end on their location's
// plans page instead of the generic dashboard. Consumed and cleared by the
// last onboarding step.
export const post_onboarding_path = useSessionStorage('post_onboarding_path', null)